import { ViewLegendContainer } from '@ardoq/graph';
import { getActiveDiffMode } from 'scope/activeDiffMode$';
import { isInScopeDiffMode } from 'scope/scopeDiff';
import { useViewLegendSubscription } from 'views/viewLegend/useViewLegendSubscription';
import {
  ViewLegend,
  getActiveConditionalFormattingForLegend,
  type ComponentTypeForLegend,
} from '@ardoq/view-legend';
import type { I18nLocale } from '@ardoq/i18n';
import { getViewLegendLabels } from 'viewLegend/getViewLegendLabels';

type ComponentMatrixViewLegendProps = {
  isLegendActive: boolean;
  legendComponentTypes: ComponentTypeForLegend[];
  i18nLocale: I18nLocale;
};

const ComponentMatrixViewLegend = ({
  isLegendActive,
  legendComponentTypes,
  i18nLocale,
}: ComponentMatrixViewLegendProps) => {
  const activeDiffMode = getActiveDiffMode();
  const isScopeDiffMode = isInScopeDiffMode();
  const heightOffset = useViewLegendSubscription();
  return (
    <ViewLegendContainer heightOffset={heightOffset} visible={isLegendActive}>
      <ViewLegend
        activeDiffMode={isScopeDiffMode ? activeDiffMode : null}
        componentTypes={legendComponentTypes}
        activeConditionalFormatting={getActiveConditionalFormattingForLegend(
          i18nLocale
        )}
        labels={getViewLegendLabels(i18nLocale)}
      />
    </ViewLegendContainer>
  );
};

export { ComponentMatrixViewLegend };
